<template>
    <widget :title="title" :router="router" :class="'widget_level'+widgetType">
        <template slot="choose_info">
            <div style="white-space:nowrap">
                <selectCom :tabList="gradeInfos" @getTab="getTerm" v-if="gradeInfos.length > 0" type="grade"></selectCom>
                <selectCom :tabList="typeList" @getTab="getTab" v-if="typeList.length > 0"></selectCom>
            </div>
        </template>
        <div class="widget_cont">
            <div class="elective_left" v-if="widgetType == 3 || (widgetType == 1 && activeName == '选课进度') || (widgetType == 2 && activeName == '选课进度')">
                <div v-if="widgetType == 2 && tableData.courseSelectionStatistics" class="selection_text">
                    总选课人数 {{tableData.courseSelectionStatistics.courseSelectionStatistics}}人 ，
                    已选课人数{{tableData.courseSelectionStatistics.electiveCourseEdNum}} 人，
                    部分选课人数{{tableData.courseSelectionStatistics.partCourseNum}}人， 
                    未选课人数 {{tableData.courseSelectionStatistics.nonElectiveCourseNum}}人</div>
                <div class="selection_title" v-if="widgetType == 3">选课进度</div>
                <div ref="course_selection" style="width:100%;height:220px;"></div>
            </div>
            <div class="elective_right">
                
                <div class="examination_statistics" v-if="activeName == '选考课程'">
                    <div class="examination_list" v-for="(course,index) in tableData.chooseStatisticsLists" :key="index">
                        <div class="info">
                            <span :style="'background:'+colors[index]"><img src="../img/widget/course.png"></span>
                            <div><span class="num">{{course.courseNum}}</span>人</div>
                            <div class="course_name cont_text_overflow" :title="course.courseName">{{course.courseName}}</div>
                        </div>
                        <div class="per"><div :style="'width:'+ course.coursePer +'%;background:'+colors[index]"></div></div>
                        <span :style="'color:'+colors[index]" class="per_val">{{course.coursePer}}%</span>
                    </div>
                </div>
                <div class="noData" v-if="tableData.chooseStatisticsLists.length == 0 && activeName == '选考课程'"><img src="~css_img/icon_emptypage.png"></div>

                <div v-show="activeName == '选修课程'" class="class_selection" ref="class_selection_xx" style="width:100%;height:240px;"></div>
            </div>
        </div>
    </widget>
</template>
<script>
    import widget from './warp'
    import selectCom from './select'
    import widgetFilter from './widgetFilter.js'
    import electiveCourseOption from './electiveCourseOption.js'
    export default {
        components: {
            widget,
            selectCom
        },
        props:{
            title:{
                type:String
            },
            swWidth:{
                type:Number
            },
            item:{
                type:Object
            }
        },
        filters:{
            format:function(val){
                return '.'+val.split('.')[1]
            }
        },
        data(){
            return {
                widgetType:1,
                activeName:'',
                router:'arrange_choose_list',
                tabList:['高一','高二'],
                typeList:[],
                myChart1:null,
                myChart2:null,
                myChart3:null,
                tableData:{
                    gradeInfos:[],
                    chooseStatisticsLists:[],
                    electiveCoursesLists:[]
                },
                colors:['#5d81ff','#4EDFB2','#1BEEFF','#73D052','#FF5BA8','#F9CF32'],
                widgetUrl:'',
                gradeId:'',
                schoolId:window.appframe.$store.state.userInfo.schoolId,
                campusId:window.appframe.$store.state.userInfo.campusId,
                gradeInfos:[]
            }
        },
        mounted(){
            let vm = this
            vm.widgetType = _.cloneDeep(vm.swWidth)

            if(vm.widgetType == 3){
                vm.typeList = ['选考课程','选修课程']
            }else{
                vm.typeList = ['选课进度','选考课程','选修课程']
            }
            vm.activeName = vm.typeList[0]
            vm.$nextTick(function(){
                if(vm.item.configList.length > 0){
                    let configList = vm.item.configList
                    vm.configList = widgetFilter.getFieldMap(configList)
                    let stemp = []
                    for(let i in vm.configList){
                        stemp.push(vm.configList[i])
                    }
                    vm.widgetUrl = stemp[0].apiUrl
                    vm.querySelect()
                }
            })
        },
        methods:{
            querySelect(){
                let vm = this
                if(vm.schoolId != '' && vm.campusId != ''){
                    let obj = {
                        schoolId:vm.schoolId,
                        campusId:vm.campusId,
                        gradeId:''
                    }
                    http.get('/gateway/arrange-course/widget',{params:obj}).then(function(xhr){
                        vm.gradeInfos = xhr.data.gradeInfos
                        vm.gradeId = vm.gradeInfos[0].id
                        vm.query()
                    })
                }else{
                    vm.courseSelection()
                }
            },
            query(){
                let vm = this
                if(vm.schoolId != '' && vm.campusId != ''){
                    let obj = {
                        schoolId:vm.schoolId,
                        campusId:vm.campusId,
                        gradeId:vm.gradeId
                    }
                    http.get('/gateway/arrange-course/widget',{params:obj}).then(function(xhr){
                        let objectA = xhr.data
                        let simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                        var newObj = new Object();
                        vm.tableData = widgetFilter.showProps(objectA,'',simpleMap,newObj)
                        vm.$nextTick(function(){
                            if(vm.widgetType == 3){//选课进度
                                vm.courseSelection()
                            }
                            if(vm.activeName == '选修课程'){
                                vm.classSelection()
                            }
                            if(vm.activeName == '选课进度'){
                                vm.courseSelection()
                            }
                        })
                    })
                }
            },
            courseSelection(){//选课进度
                let vm = this
                if(!vm.tableData.courseSelectionStatistics){
                    vm.tableData.courseSelectionStatistics = {
                        electiveCourseEdNum: 0,
                        nonElectiveCourseNum: 0,
                        partCourseNum: 0
                    }
                }
                let data = [
                    {value:vm.tableData.courseSelectionStatistics.electiveCourseEdNum, name:'已选课'},
                    {value:vm.tableData.courseSelectionStatistics.nonElectiveCourseNum, name:'未选课'},
                    {value:vm.tableData.courseSelectionStatistics.partCourseNum, name:'部分选课'}
                ]
                let myChart = echarts.init(vm.$refs["course_selection"])
                let option = _.cloneDeep(electiveCourseOption.courseSelectionOption)
                
                if(vm.widgetType != 1){
                    let winW = $(window).width()
                    if(winW < 1440){
                        option.series[0].center = ['60%','60%']
                    }else{
                        option.series[0].center = ['50%','60%']
                    }
                }
                $(window).resize(function(){
                    if(vm.widgetType != 1){
                        let winW = $(window).width()
                        if(winW < 1440){
                            option.series[0].center = ['60%','60%']
                        }else{
                            option.series[0].center = ['50%','60%']
                        }
                    }
                    myChart.resize();
                })

                
                if(vm.widgetType == 1){
                    option.legend.orient = 'horizontal'
                    option.legend.top = 0
                    option.legend.left = 'center'
                    
                }
                option.series[0].data = data
                myChart.setOption(option);
                
            },
            classSelection(){//选修课程
                let vm = this
                let stemp = vm.tableData.electiveCoursesLists
                let courseName = [],courseNum = [],dataPer = []
                for(let i=0;i<stemp.length;i++){
                    courseName.push(stemp[i].courseName)
                    courseNum.push(stemp[i].courseNum)
                    dataPer.push(stemp[i].coursePer)
                }
                let myChart = echarts.init(vm.$refs["class_selection_xx"])
                let option = {
                        title:{
                            text: '选修统计',
                            left:'center',
                            textStyle:{
                                fontSize:14,
                                color:'#666'
                            }
                        },
                        color: ['#3398DB'],
                        tooltip : {
                            trigger: 'axis',
                            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                                type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                            },
                            formatter: function (param) {
                                return '<div>' + param[0].name + '</div><div>'+param[0].value+'人，('+dataPer[param[0].dataIndex]+'%)</div>'
                            }
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            top:'17%',
                            containLabel: true
                        },
                        xAxis : [
                            {
                                type : 'category',
                                data : courseName,
                                axisTick: {
                                    alignWithLabel: true
                                }
                            }
                        ],
                        yAxis : [
                            {
                                type : 'value'
                            }
                        ],
                        series : [
                            {
                                name:'直接访问',
                                type:'bar',
                                barWidth: 14,
                                data:courseNum,
                                itemStyle: {
                                    normal: {
                                        barBorderRadius:7,
                                        color: new echarts.graphic.LinearGradient(
                                            0, 0, 0, 1,
                                            [
                                                {offset: 0, color: '#63E7C9'},
                                                {offset: 1, color: '#42B5F9'}
                                            ]
                                        )
                                    },
                                },
                            }
                        ]
                    }
                    myChart.setOption(option);
                electiveCourseOption.classSelectionOption = option
            },
            getTab(data){
                let vm = this
                vm.activeName = data
                if(data == '选修课程'){
                    vm.$nextTick(function(){
                        vm.classSelection()//选修课程
                    })
                }
                if(data == '选课进度'){
                    vm.$nextTick(function(){
                        vm.courseSelection()
                    })
                }
            },
            getTerm(data){
                this.gradeId = data.id
                this.query()
            }
        }
    }
</script>
<style lang="less" scoped>
    .widget_cont{
        height: 280px;
        overflow: hidden;
    }
    .elective_left{
        padding-top: 30px;
        position: relative;
    }
    .widget_level2,
    .widget_level3{
        .selection_text{
            text-align: center;
            color: #666;
            font-size: 12px;
            position: absolute;top:30px;left: 0;right: 0;
        }
    }
    .widget_level3{
        .widget_cont{
            display: flex;
        }
        .elective_left{
            width: calc(~'33.33% - 20px');
        }
        .elective_right{
            width: calc(~'66.66% - 20px');
            margin-left:40px;
        }
    }
    .widget_level1{
        .elective_right{
            margin-top: 35px;
        }
        .examination_list{
            padding: 0 10px;
        }
        .info{
            height: 50px;
            margin-bottom:12px;
            &>span{
                border-radius: 50%;
                width: 30px;
                height: 30px;
                float: left;
                margin-right:5px;
                img{
                    width: 30px;
                }
            }
            .num{
                font-size:14px;
                font-weight: bold;
                line-height: 30px;
            }
            .course_name{
                color: #666;
                line-height: 20px;
            }
        }
    }
    .widget_level1,
    .widget_level2,
    .widget_level3{
        .elective_right{
            position: relative;
            margin-top:30px;
        }
        .class_selection_tit{
            padding-top: 30px;
        }
        .selection_title,
        .class_selection_tit{
            text-align: center;
            color: #666;
            font-size: 14px;
            position: absolute;left: 0;right: 0;top:0;
        }
        .selection_title{top:30px;}
        .examination_statistics{
            display: flex;
            flex-wrap: wrap;
            .examination_list{
                width: 33.33%;
            }
        }
        .examination_list{
            margin-bottom: 45px;
            border-left:1px solid #E5E7EA;
            position: relative;
            .per{
                height: 10px;
                border-radius: 5px;
                overflow: hidden;
                background: #F2F3F7;
                div{
                    height: 100%;
                }
            }
            .per_val{
                position: absolute;
                bottom:-20px;
                font-size: 12px;
            }
        }
        .examination_list:nth-child(3n+1){
            border-left: none;
        }
    }
    .widget_level2,
    .widget_level3{
        .examination_list{
            padding:0 30px;
        }
        .info{
            height: 50px;
            margin-bottom:22px;
            &>span{
                border-radius: 50%;
                width: 50px;
                height: 50px;
                float: left;
                margin-right:25px;
            }
            .num{
                font-size:20px;
                font-weight: bold;
            }
            .course_name{
                color: #666;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/electiveCourse.vue